var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.928 5.82203L18.6975 1.03633C19.413 0.321224 20.5687 0.321224 21.2841 1.03633L26.072 5.82203H32.8411C33.85 5.82203 34.6755 6.64715 34.6755 7.65563V14.4216L39.4634 19.2073C40.1789 19.9224 40.1789 21.0776 39.4634 21.7927L34.6755 26.5784V33.3444C34.6755 34.3529 33.85 35.178 32.8411 35.178H26.072L21.2841 39.9637C20.5687 40.6788 19.413 40.6788 18.6975 39.9637L13.9097 35.178H7.14056C6.13162 35.178 5.30612 34.3529 5.30612 33.3444V26.5784L0.536574 21.7927C-0.178858 21.0776 -0.178858 19.9224 0.536574 19.2073L5.32447 14.4216V7.65563C5.32447 6.64715 6.14997 5.82203 7.15891 5.82203H13.928ZM8.99335 9.48923V15.9252L4.42559 20.4908L8.99335 25.0565V31.4924H15.4322L20 36.0581L24.5678 31.4924H31.0067V25.0565L35.5744 20.4908L31.0067 15.9252V9.48923H24.5678L20 4.92356L15.4322 9.48923H8.99335ZM20 27.8252C15.9459 27.8252 12.6622 24.5431 12.6622 20.4908C12.6622 16.4386 15.9459 13.1564 20 13.1564C24.0541 13.1564 27.3378 16.4386 27.3378 20.4908C27.3378 24.5431 24.0541 27.8252 20 27.8252ZM20 24.158C22.0179 24.158 23.6689 22.5078 23.6689 20.4908C23.6689 18.4739 22.0179 16.8236 20 16.8236C17.9821 16.8236 16.3311 18.4739 16.3311 20.4908C16.3311 22.5078 17.9821 24.158 20 24.158Z",
    fill: "#20262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.b2f2ffad128e9981c7d53e20c005306e.svg";
export { ForwardRef as ReactComponent };